
const m = window.require("truth-helpers/helpers/gt");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
